import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, TextField, Paragraph } from '@fs/zion-ui'

import React, { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../hooks/useNotifications'
import { restorePerson } from '../../services/personService'
import { PersonContext } from '../person/PersonContext'

export default function RestoreTombstonedPersonDialogOverlay({ ...overlay }) {
  const { t } = useTranslation()
  const { currentPerson, fetchCurrentPerson } = useContext(PersonContext)
  const [reason, setReason] = useState()
  const { error } = useNotifications()
  const { isOpen, transitioning } = overlay
  const focusElementRef = useRef()

  const confirmBtnOnClick = async () => {
    try {
      overlay.close()
      await restorePerson(currentPerson.id, reason)
      fetchCurrentPerson()
    } catch (err) {
      error(
        t('metadata.errors.restoringPerson', {
          defaultValue: `Error restoring a person: ${err.message || ''}`,
          message: err.message || '',
        }),
        err
      )
    }
  }

  useEffect(() => {
    if (!isOpen && transitioning) {
      // The overlay is currently exiting (still transitioning out)
      setReason()
    }
  }, [isOpen, transitioning])

  return (
    <DialogOverlay
      focusRef={focusElementRef}
      {...overlay}
      title={t('person.summary.restoreTombstonedPersonDialog.heading', 'Restore Tombstoned Person')}
      subtitle={t('person.summary.restoreTombstonedPersonDialog.subheading', '{ personId }', {
        personId: currentPerson.id,
      })}
    >
      <>
        <Paragraph size="sm">
          {t(
            'person.summary.restoreTombstonedPersonDialog.placeholder',
            'Please provide a reason for restoring this tombstoned person'
          )}
        </Paragraph>
        <TextField value={reason} onChange={(e) => setReason(e.target.value)} ref={focusElementRef} />
      </>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="high" onClick={confirmBtnOnClick} disabled={!reason}>
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button emphasis="medium" onClick={overlay.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
